export const DeleteIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M2 3.99999H14M12.6667 3.99999V13.3333C12.6667 14 12
            14.6667 11.3333 14.6667H4.66667C4 14.6667 3.33333 14 3.33333 13.3333V3.99999M5.33333
            3.99999V2.66666C5.33333 1.99999 6 1.33333 6.66667 1.33333H9.33333C10 1.33333 10.6667 1.99999
            10.6667 2.66666V3.99999M6.66667 7.33333V11.3333M9.33333 7.33333V11.3333"
      stroke="#373D40"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
